import Vue from "vue";
import Router from 'vue-router'
import store from "@/store"
import { Toast } from 'vant'
import loginApi from "@/api/login"
import front from './front';
Vue.use(Router)
export const createRouter = () =>
  new Router({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [
      {// 首页重定向
        path: '/',
        name: 'home',
        redirect: '/standard-library',
        children: front,
        component: () => import("@/components/frontLayout.vue")
      },
      {// 登录页
        path: '/login',
        name: 'login',
        component: () => import("../views/standardLibrary/login.vue"),
        meta: {
          title:'标准列表',
          requireAuth: true
        },
      },
    ],
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
  })
  const router = createRouter();
  router.beforeEach(async(to, from, next) => {
    if(to.query.token){// 路由中携带token参数
      loginApi.loginFromAsiaRequest({token: to.query.token}).then(res=>{
        if(res.code == '200'){
          store.dispatch('user/login',res.data.token)
          store.dispatch('user/setUserInfo',res.data)
          store.dispatch('user/setIsToken', true)
          localStorage.setItem('access_token', res.data.token)
          next()
        }else{
          store.dispatch('user/restToken')
          store.dispatch('user/setIsToken', false)
          localStorage.setItem('access_token', '')
          Toast.fail("验证失败")
        }
      })
    }else if(!to.query.token){// 未携带token参数
      if(to.query.ticket){// 路由中携带ticket参数
        const newPath = to.fullPath.replace('ticket', 'ticketSyy')
        window.open(newPath, "_self")
      }else{// 未携带ticket参数
        if(to.query.ticketSyy) { /* 携带处理后的ticketSyy参数 */
          loginApi.loginFromSyyRequest({ticket: to.query.ticketSyy}).then(res=>{
            if(res.code == '200'){
              store.dispatch('user/login',res.data.token)
              store.dispatch('user/setUserInfo',res.data)
              localStorage.setItem('access_token', res.data.token)
              store.dispatch('user/setIsTicket', true)
              next()
              
              /* let index = to.fullPath.lastIndexOf("ticketSyy=")
              let newPath = ""
              if(index > 0) {
                newPath = to.fullPath.substring(0, index-1)
              } else {
                newPath = to.fullPath
              }
              window.open(newPath, "_self") */
            }else{
              store.dispatch('user/restToken')
              store.dispatch('user/setIsTicket', false)
              localStorage.setItem('access_token', "")
              Toast.fail("验证失败")
            }
          })
        } else {
          if(process.env.NODE_ENV == 'dev' || process.env.NODE_ENV == 'test'){
            next()
          }else{
            console.log(store.state.user.isTicket, '验证ticket的结果')
            console.log(store.state.user.isToken, '验证token的结果')
            if(store.state.user.isTicket || store.state.user.isToken){
              next()
            }else{
              Toast.fail("验证失败")
            }
          }
        }
      }
    }
  });
export default router